var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0489 18.6307C9.86139 18.818 9.60722 18.9232 9.34222 18.9232C9.07722 18.9232 8.82305 18.818 8.63555 18.6307L0.302219 10.2974C0.114952 10.1099 0.00976563 9.8557 0.00976562 9.5907C0.00976562 9.3257 0.114952 9.07153 0.302219 8.88403L8.63555 0.550699C8.7271 0.45245 8.8375 0.373647 8.96017 0.318991C9.08283 0.264335 9.21525 0.234947 9.34952 0.232578C9.48379 0.230208 9.61717 0.254908 9.74168 0.305202C9.8662 0.355497 9.97931 0.430356 10.0743 0.525315C10.1692 0.620273 10.2441 0.733385 10.2944 0.857902C10.3447 0.98242 10.3694 1.11579 10.367 1.25006C10.3646 1.38433 10.3352 1.51675 10.2806 1.63942C10.2259 1.76208 10.1471 1.87248 10.0489 1.96403L3.42222 8.5907H22.6756C22.9408 8.5907 23.1951 8.69606 23.3827 8.88359C23.5702 9.07113 23.6756 9.32548 23.6756 9.5907C23.6756 9.85592 23.5702 10.1103 23.3827 10.2978C23.1951 10.4853 22.9408 10.5907 22.6756 10.5907H3.42222L10.0489 17.2174C10.2362 17.4049 10.3413 17.659 10.3413 17.924C10.3413 18.189 10.2362 18.4432 10.0489 18.6307Z",
    fill: "#546169"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyArrowLeft);
export default __webpack_public_path__ + "static/media/grey-arrow-left.4e33d985337e8b0eb423687dbfb2edbf.svg";
export { ForwardRef as ReactComponent };